const { CrudModel } = require('./crud');

export class ShiftModel extends CrudModel {
	constructor() {
		super('admin/shift', [
			{ key: "deletionReason", name: "Justificativa", kind: "select", options: [
				{ name: "Hospital cancelou", value: "Hospital cancelou" },
				{ name: "Outra (descrever abaixo)", value: "Outra (descrever abaixo)" },
			]},
			{ key: "autoAnnounce", name: "Anunciar automaticamente", kind: "checkbox" },
			{ key: "splitDuration", name: "Nova duração (h)", kind: "text", vueMask: "[\"##:##\"]" },
		]);
	}

	async announce(id: string | number, auditNotes: string) {
		return this.executeAction(id, "announce", { auditNotes });
	}

	async disableAnnouncement(id: string | number, auditNotes: string) {
		return this.executeAction(id, "disableAnnouncement", { auditNotes });
	}

	async changeProfessionalUser(id: string | number, professionalUserId: string, auditNotes: string) {
		return this.executeAction(id, "changeProfessionalUser", { professionalUserId, auditNotes });
	}

	async split(id: string | number, duration: string, auditNotes: string) {
		return this.executeAction(id, "split", { duration, auditNotes });
	}


	async respondApplication(id: string | number, newProfessionalUserId: string, response: "ACCEPT" | "REFUSE", auditNotes: string) {
		return this.executeAction(id, "respondApplication", { newProfessionalUserId, response, auditNotes });
	}

	async getPayroll(params: any) {
		return this.get("payroll", params);
	}

	async generateBankingFile(payrollFilter: any, professionalUserIds: number[] | null, bankingAccountId: number, paymentMode?: 'GROSS' | 'NET') {
		return this.executeAction(null, "generateBankingFile", { payrollFilter, professionalUserIds, bankingAccountId, paymentMode });
	}

	async deleteShift(id: string | number, auditNotes: string) {
		return this.executeAction(id, "delete", { auditNotes });
	}
}

export default new ShiftModel();
